import Image from 'app/Components/Shared/Image/image';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import MarketingItemsBlockData from 'app/Models/Content/MarketingItemsBlockData';
import MarketingBlockData from 'app/Models/Content/MarketingBlockData';
import {Container} from 'reactstrap';

import React from 'react';
import {getImageProps} from 'app/utilities/ImageProps';

const MarketingItemsBlock = ({data, context}: ComponentProps<MarketingItemsBlockData>) => {
  const items = data.items.expandedValue as MarketingBlockData[];
  return (
    <Container className='MarketingItemsBlock'>
      <div className='MarketingItemsBlock__items'>
        {items.map((item, i) => {
          return (
            <div className='MarketingItemsBlock__item' key={i}>
              <div className='MarketingItemsBlock__item__title'>{item.title.value}</div>
              <div className='MarketingItemsBlock__item__subtitle'>{item.subtitle.value}</div>
              <a className='MarketingItemsBlock__item__link' href={item.buttonLink.value}>
                {item.buttonLinkTitle.value}
              </a>
              <Image className='MarketingItemsBlock__item__image' {...getImageProps(item.titleAsImage, context)} />
            </div>
          );
        })}
      </div>
    </Container>
  );
};

export default MarketingItemsBlock;
